var map = {
	"./csv.svg": "EnYD",
	"./doc.svg": "MQGx",
	"./jpeg.svg": "g+6l",
	"./jpg.svg": "3Xqq",
	"./pdf.svg": "8tvZ",
	"./xls.svg": "M381",
	"./xlsx.svg": "T/PZ"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "MSC2";


//////////////////
// WEBPACK FOOTER
// ./static/img/file ^\.\/.*\.svg$
// module id = MSC2
// module chunks = 248